import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect from "react-native-picker-select";
import { FontAwesome5, Feather, MaterialIcons } from "@expo/vector-icons";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";
import { autolize_Lv } from "../../json/utis";
const { width, height } = Dimensions.get("window");
export default function profileuser({ navigation, route }) {
  const item = route.params.item;
  const focus = useIsFocused();
  const token = useRecoilValue(tokenState);
  const [data, setdata] = useState({});
  const [user, setuser] = useState({});
  const [tel, setTel] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [subDistrict, setSubDistrict] = useState("");
  const [district, setDistrict] = useState("");
  const [province, setProvince] = useState("");
  const [postcode, setPostcode] = useState("");
  const [totalDistance, setTotalDistance] = useState("");
  const timeout = React.useRef(null);

  const utis =
    user.user_accounts != undefined && user.user_accounts.total_distance;

  async function getuserin() {
    const response = await apiservice({
      path: "/admin/getdataByuser?id=" + item.id,
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      setdata(response.data);
    }
  }

  async function getuser() {
    const response = await apiservice({
      path: "/admin/getuser?id=" + item.id,
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setuser(response.data.data);
    }
  }

  useEffect(() => {
    setTel(user?.tel || "");
    setShippingAddress(user?.full_address?.ShippingAddress || "");
    setSubDistrict(user?.full_address?.subDistrict || "");
    setDistrict(user?.full_address?.district || "");
    setProvince(user?.full_address?.province || "");
    setPostcode(user?.full_address?.postcode || "");
    setTotalDistance(user?.user_accounts?.total_distance || "");
  }, [user]);

  const placeholder1 = {
    label: "Status",
    value: null,
    color: "#777777",
  };

  const items1 = [
    { label: "Active", value: "Active" },
    { label: "Block", value: "Block" },
  ]

  useEffect(() => {
    getuserin();
    getuser();
  }, [focus]);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              USER{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>PROFILE</Text>
              </Text>
            </Text>
            <View style={{ flexDirection: "row" }}>
              <TouchableOpacity
                style={[styles.touchadd, { backgroundColor: "#FCC81D" }]}
              >
                <Text style={styles.textadd}>PROFILE</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => navigation.navigate("Payment", user)}
                style={[
                  styles.touchadd,
                  { backgroundColor: "#fff" },
                  { marginLeft: 10 },
                ]}
              >
                <Text style={styles.textadd}>PAYMENT HISTORY</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View style={[styles.viewfree, { marginTop: 20 }]}>
            <View style={[styles.viewfor]}>
              <View style={{ flexDirection: "row" }}>
                <View style={{ flexDirection: "row" }}>
                  <TouchableOpacity
                    style={{ justifyContent: "center", marginRight: 20 }}
                  >
                    <Image
                      style={{
                        width: 80,
                        height: 80,
                        justifyContent: "center",
                        marginTop: -20,
                      }}
                      source={{
                        uri:

                          user.image_Profile,
                      }}
                    />
                  </TouchableOpacity>
                  <View>
                    {user.name == "" || user.name == null ? (
                      <Text style={[styles.textname, { marginTop: 10 }]}>
                        {user.username}
                      </Text>
                    ) : (
                      <Text style={[styles.textname, { marginTop: 10 }]}>
                        {user.name}
                      </Text>
                    )}
                  </View>
                </View>
                <View style={{ marginLeft: 30 }}>
                  <Text style={styles.textname2}>Email : {user.email}</Text>
                  <Text style={styles.textname2}>
                    ID Code : {user?.id + 100000}
                  </Text>
                  <Text style={styles.textname2}>
                    Level : {autolize_Lv(parseInt(utis)).lv}
                  </Text>
                  <Text style={styles.textname2}>
                    Rank : {autolize_Lv(parseInt(utis)).rank} Class
                  </Text>
                </View>
                <TouchableOpacity
                  style={{ justifyContent: "center", marginLeft: 40 }}
                >
                  <Image
                    style={{
                      width: 80,
                      height: 100,
                      alignSelf: "center",
                      justifyContent: "center",
                    }}
                    source={autolize_Lv(parseInt(utis)).grid}
                  />
                </TouchableOpacity>
              </View>
              <View style={{ flexDirection: "row" }}>
                <Image
                  style={{
                    width: 28,
                    height: 35,
                    alignSelf: "center",
                    marginRight: 5,
                  }}
                  source={require("../../image/Icon awesome-running.png")}
                />
                <Text style={styles.textdate}>
                  {user?.user_accounts?.wallet?.cal || 0}
                </Text>
                <Image
                  style={{
                    width: 35,
                    height: 35,
                    alignSelf: "center",
                    marginRight: 5,
                  }}
                  source={require("../../image/coin.png")}
                />
                <Text style={styles.textdate}>
                  {user?.user_accounts?.wallet?.gold || 0}
                </Text>
              </View>
            </View>
            <View>
              <Text style={styles.textname}>Role</Text>
              <Text style={styles.textname1}>{user.role}</Text>
              <Text style={[styles.textname, { marginTop: 10 }]}>Status</Text>
              <RNPickerSelect
                placeholder={placeholder1}
                style={{
                  inputWeb: {
                    width: width * 0.23,
                    height: 30,
                    borderWidth: 1,
                    borderColor: "#ccc",
                    paddingLeft: 10,
                    borderRadius: 5,
                    color: "#777777",
                    fontFamily: "Prompt-Regular",
                    alignSelf: "center",
                  },
                }}
                value={user?.link ? "Active" : "Block"}
                onValueChange={async (value) => {
                  const response = await apiservice({
                    path: "/admin/edit-profile",
                    method: "put",
                    body: { ...user, link: value == "Active" ? true : false },
                    token: token.accessToken,
                  });

                  if (response?.status == 200) {
                    getuserin();
                    getuser();
                  }
                }}
                items={items1}
              />
            </View>
          </View>
          <Text style={styles.textfree2}>SHIPPING ADDRESS</Text>
          <View style={[styles.view, { marginBottom: 10 }]}>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>เบอร์โทรศัพท์</Text>
              <TextInput
                value={tel}
                onChangeText={(t) => setTel(t)}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>ที่อยู่</Text>
              <TextInput
                value={shippingAddress}
                onChangeText={(t) => setShippingAddress(t)}
                multiline
                style={styles.inputadd1}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>แขวง (ตำบล)</Text>
              <TextInput
                value={subDistrict}
                onChangeText={(t) => setSubDistrict(t)}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>เขต (อำเภอ)</Text>
              <TextInput
                value={district}
                onChangeText={(t) => setDistrict(t)}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>จังหวัด</Text>
              <TextInput
                value={province}
                onChangeText={(t) => setProvince(t)}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>รหัสไปรษณีย์</Text>
              <TextInput
                value={postcode}
                onChangeText={(t) => setPostcode(t)}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>ระยะวิ่ง (เมตร)</Text>
              <TextInput
                value={totalDistance}
                onChangeText={async (text) => {
                  setTotalDistance(text);
                  clearTimeout(timeout.current);
                  timeout.current = setTimeout(async () => {
                    const response = await apiservice({
                      path: "/admin/info.edit-profile",
                      method: "put",
                      body: {
                        id: user.id,
                        total_distance: text,
                      },
                      token: token.accessToken,
                    });

                    if (response?.status == 200) {
                      getuserin();
                      getuser();
                    }
                  }, 500);
                }}
                style={styles.inputadd}
              />
            </View>
            <View style={{ alignItems: "flex-end", marginTop: 10 }}>
              <TouchableOpacity
                style={styles.saveButton}
                onPress={async () => {
                  const body = {
                    ...user,
                    tel: tel,
                    full_address: {
                      ...user.full_address,
                      ShippingAddress: shippingAddress,
                      subDistrict: subDistrict,
                      district: district,
                      province: province,
                      postcode: postcode,
                    },
                  };

                  const response = await apiservice({
                    path: "/admin/edit-profile",
                    method: "put",
                    body,
                    token: token.accessToken,
                  });

                  if (response?.status == 200) {
                    getuserin();
                    getuser();
                    alert("Update profile successfully");
                  }
                }}
              >
                <Text style={styles.saveText}>SAVE</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View style={[styles.viewfree, { marginBottom: 20 }]}>
            <TouchableOpacity
              onPress={() => navigation.navigate("EventList", user)}
              style={styles.viewevent}
            >
              <View>
                <Text style={styles.text}>COMPLETE</Text>
                <Text style={styles.text1}>{data.complete}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#2DCE98" }]}>
                <FontAwesome5
                  name="user-alt"
                  size={25}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => navigation.navigate("EventList", user)}
              style={styles.viewevent}
            >
              <View>
                <Text style={styles.text}>EVENT</Text>
                <Text style={styles.text1}>{data?.event}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#2DCE98" }]}>
                <Feather
                  name="file-text"
                  size={25}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </TouchableOpacity>
            <TouchableOpacity style={styles.viewevent}>
              <View>
                <Text style={styles.text}>FREE POINT</Text>
                <Text style={styles.text1}>{data.freepoint}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#7764E4" }]}>
                <FontAwesome5
                  name="coins"
                  size={24}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </TouchableOpacity>
            <View style={styles.viewevent}>
              <View>
                <Text style={styles.text}>DISCOUNT</Text>
                <Text style={styles.text1}>{data.discount}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#7764E4" }]}>
                <MaterialIcons
                  name="card-giftcard"
                  size={24}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 180,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewfor: {
    width: width * 0.55,
    height: 150,
    backgroundColor: "#FFF",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  textname1: {
    fontSize: 16,
    color: "#444444",
    fontFamily: "Prompt-Regular",
  },
  textname2: {
    fontSize: 16,
    color: "#000",
    fontFamily: "Prompt-Regular",
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfree2: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 20,
    borderRadius: 10,
  },
  viewmainfor: {
    flexDirection: "row",
    width: width * 0.3,
    justifyContent: "space-between",
  },
  inputadd: {
    width: width * 0.16,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd1: {
    width: width * 0.16,
    height: 100,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  viewevent: {
    width: width * 0.2,
    height: 100,
    backgroundColor: "#fff",
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    padding: 20,
  },
  imgicon: {
    width: 50,
    height: 50,
    alignSelf: "flex-end",
    justifyContent: "center",
    borderRadius: 25,
    marginTop: -50,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#8898AA",
  },
  text1: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#4D4F5C",
  },
  saveButton: {
    backgroundColor: "#2DCE98",
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 6,
  },
  saveText: {
    color: "#fff",
    fontFamily: "Prompt-Regular",
    fontSize: 16,
  },
});
